import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { WACAvatarProps, WACAvatar } from "./avatar";

export interface UserDetailsCardProps extends WACAvatarProps {
    email: string;
}

export const UserDetailsCard = ({
    email,
    name,
    size,
    src
}: UserDetailsCardProps) => {
    return (
        <div css={userDetailsContainer}>
            <WACAvatar name={name} src={src} size={size} />
            <div css={userInfoContainer}>
                <div css={userNameLabel}>{name} </div>
                <div css={userEmailLabel}>{email} </div>
            </div>
        </div>
    );
};

const userDetailsContainer = css({
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    padding: `${token("space.100")} ${token("space.200")}`,
    width: "250px",
    backgroundColor: "#172b4d"
});

const userInfoContainer = css({
    display: "flex",
    flexFlow: "column",
    marginInlineStart: token("space.100")
});

const userNameLabel = css({
    fontSize: token("space.200"),
    lineHeight: token("space.250"),
    color: "#ffffff"
});

const userEmailLabel = css({
    fontSize: token("space.150"),
    lineHeight: token("space.150"),
    color: "#c1c7d0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});
